import React, { useEffect } from 'react';
import { useLazyGetPageQuery } from '../../../redux/actions/Customer/FooterCustomer';
import { LegalPageLayout } from '../../../components/customer/LegalPageLayout';

export const CancellationPolicyScreen: React.FC = () => {
    const [triggerGetPage, { data: response, isLoading, isError }] = useLazyGetPageQuery();

    useEffect(() => {
        triggerGetPage(5); // WebsitePageType.CancellationPolicy = 5
    }, [triggerGetPage]);

    return (
        <LegalPageLayout
            title="Cancellation Policy"
            subtitle="Learn about our order cancellation rules."
            isLoading={isLoading}
            isError={isError}
            contentData={response?.value?.data || null}
        />
    );
};
export default CancellationPolicyScreen;